<template>
  <div class="dpi px">
    <div class="list">
      <div
        class="item"
        v-for="(dpi, index) in DPItime"
        :key="index"
        :class="{ active: currentID == index, selected: dpi < 0 }"
      >
        <div class="radio" @click.stop="onItemClick(index)"></div>
        <a-slider
          class="slider"
          :value="DPItime[index] || undefined"
          @change="onSliderChange(index, $event)"
          :max="maxDPI"
          :tooltipVisible="false"
        />
        <md-field class="number">
          <md-input
            class="number-input"
            @change="onSliderChange(index, $event.target.value)"
            v-model="DPItime[index]"
            step="1"
          ></md-input>
        </md-field>
        <a-tooltip placement="left">
          <template slot="title">
            <sketch-picker
              class="picker"
              :value="DPIcolor[index]"
              disableAlpha
              @input="onColorInput(index, $event)"
              :preset-colors="[
                '#D0021B',
                '#F5A623',
                '#F8E71C',
                '#8B572A',
                '#7ED321',
                '#417505',
                '#BD10E0',
                '#9013FE',
                '#4A90E2',
                '#50E3C2',
                '#B8E986',
                '#000000',
                '#444444',
                '#888888',
                '#CCCCCC',
                '#FFFFFF',
              ]"
            />
          </template>
          <div
            class="color"
            :style="{ backgroundColor: DPIcolor[index] }"
          ></div>
        </a-tooltip>
      </div>
    </div>
    <div class="button" @click="onSave" v-if="false">
      {{ $t("save") }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CMouseDpi",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      profile: 0, // （按键层：0~4）
      timer: 0,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
    ...mapState("mouse", {
      DPI: "DPI",
      param: "param",
      currentID: (state) => state.DPI.currentID,
      DPItime: (state) => state.DPI.DPItime,
      DPIcolor: (state) => state.DPI.DPIcolor,
    }),
    maxDPI() {
      return this.param.mouseID === 1935 ? 26000 : 30000;
    },
  },
  methods: {
    onItemClick(index) {
      if (this.DPItime[index] > 0 && this.currentID != index) {
        this.$store.dispatch("mouse/setDPI", { ...this.DPI, currentID: index });
        this.onSave();
      }
    },
    onSliderChange(index, value) {
      const DPItime = [...this.DPItime];
      DPItime[index] = Number(value);
      this.$store.dispatch("mouse/setDPI", { ...this.DPI, DPItime });
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.onSave, 200);
    },
    onColorInput(index, e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      const DPIcolor = [...this.DPIcolor];
      DPIcolor[index] = color.length === 7 ? color : "#000000";
      this.$store.dispatch("mouse/setDPI", { ...this.DPI, DPIcolor });
      this.onSave();
    },
    onSave() {
      if (this.currentID >= 0) {
        const DPItime = [
          ...this.DPItime.map((time, index) => {
            if (time > this.maxDPI) {
              return this.maxDPI;
            } else if (time < 50) {
              return 50;
            }
            return time;
          }),
        ];
        this.$store.dispatch("mouse/setDPI", { ...this.DPI, DPItime });
        this.$store.dispatch("loader/setMouseDPI", {
          profile: this.profile,
          currentID: this.currentID,
          DPItime: DPItime,
          DPIcolor: this.DPIcolor,
        });
      } else {
        this.$message.info(this.$t("mouse.dpiError"));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dpi {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .list {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .item {
      @include flex-center;
      padding: 20px 30px;
      font-size: 21px;
      border-radius: 3px;
      margin-bottom: 30px;

      .radio {
        width: 30px;
        height: 30px;
        border: 2px solid #3c3c3c;
        border-radius: 50%;
        padding: 3px;
        margin-right: 30px;
        cursor: pointer;
      }

      .slider {
        width: 300px;
        margin-right: 30px;
      }

      .number {
        width: 70px;
        font-size: 20px;
        color: #717171;
        letter-spacing: 0;
        margin: 0 30px 0 0;
        padding: 0;

        .number-input {
          width: 100%;
          text-align: center;
        }
      }

      .color {
        width: 30px;
        height: 30px;
        border-radius: 2px;
        border: 1px solid #717171;
      }

      .picker {
        color: #000000;
      }

      &.active {
        .radio::before {
          width: 100%;
          height: 100%;
          display: block;
          content: "";
          background-color: $primary-color;
          border-radius: 50%;
        }

        .number {
          color: #ffffff;
        }

        .color {
          border: 1px solid #ffffff;
        }
      }

      &.selected {
        background: #222222;
      }
    }
  }

  .button {
    @include button;
    width: 120px;
    height: 34px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss">
.dpi {
  .info {
    .item {
      .slider {
        padding: 4px 0;
        .ant-slider-rail {
          height: 6px;
          background-color: #717171 !important;
        }

        .ant-slider-track {
          height: 6px;
          background-color: #3c3c3c !important;
        }

        .ant-slider-step {
          height: 6px;
        }

        .ant-slider-handle {
          width: 30px;
          height: 30px;
          margin-top: -12px;
          background-color: #3c3c3c !important;
          border: 0;
          box-shadow: none;
        }
      }

      &.active .slider {
        .ant-slider-track {
          background-color: $primary-color !important;
        }

        .ant-slider-handle {
          background-color: $primary-color !important;
        }
      }
    }
  }
}

.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}
</style>
